/** unmak.tech/stores — sabit mağaza linkleri (düzenleme yok) */
export const STORE_LINKS = [
  {
    id: 'android',
    platform: 'Android',
    storeName: 'Google Play',
    url: 'https://play.google.com/store/apps/details?id=com.unmakmobile',
    badgeSrc: '/assets/stores/google-play-badge.svg',
    qrFileName: 'unmak-google-play-qr.png',
  },
  {
    id: 'ios',
    platform: 'iOS',
    storeName: 'App Store',
    url: 'https://apps.apple.com/app/unmak/id6801061244',
    badgeSrc: '/assets/stores/app-store-badge.svg',
    qrFileName: 'unmak-app-store-qr.png',
  },
];
